import { wait } from '../common';

export const batchActions = async <T>(actions: (() => T)[], debounceMs: number): Promise<T[]> => {
  const results: T[] = [];
  for (const action of actions) {
    results.push(action());
    await wait(debounceMs);
  }
  return results;
};
